export class Ciudad {
  id_centro_logistico: string;
  ciudad: string;
  id_tienda: string;
}

export class CiudadCotizador {
  ciudad: string;
  departamento: string;
  id_ciudad: any;
}


export class Numeros {
  valor1: number;
  valor2: number;
  valor3: number;
}
